/** Russian for `uz-settings-finance.ts`. The type makes a missing key a compile error. */
import type { uzSettingsFinance } from "./uz-settings-finance";

export const ruSettingsFinance: Record<keyof typeof uzSettingsFinance, string> = {
  "settings.nav.finance": "Финансы",
  "settings.nav.billing": "Тариф и кредиты",
  "settings.finance.title": "Настройки финансов",
  "settings.edit": "Изменить",
  "settings.toggleFailed": "Не удалось изменить",

  "tasks.accepted": "Принято",
  "priceWatch.title": "Наблюдения",
  "priceWatch.watch": "Следить за ценой",
  "priceWatch.destinations": "Направления",
  "priceWatch.destinationsHint": "Сообщим, если самое дешёвое свежее предложение на ближайшие 14 дней (на двоих) упадёт ниже прошлого результата.",
  "priceWatch.destination": "Направление",
  "priceWatch.noDestinations": "Направления агентства ещё не выбраны: Настройки, Направления.",
  "priceWatch.currency": "Валюта",
  "priceWatch.target": "Целевая цена (необязательно)",
  "priceWatch.start": "Следить",
  "priceWatch.started": "Наблюдение включено",
  "priceWatch.failed": "Не удалось включить наблюдение",
  "priceWatch.noResult": "результата пока нет",
  "priceWatch.lastResult": "последний результат: {price}",
  "priceWatch.forClient": "Для клиента",
  "priceWatch.tellClient": "Сообщить и клиенту (при наличии согласия)",
  "priceWatch.noConsent": "Наблюдение включено, но согласия клиента нет: сообщение придёт только вам.",
  "settings.branches.hours": "Часы работы",
  "settings.branches.aroundTheClock": "Круглосуточно",
  "settings.branches.hoursStart": "Начало",
  "settings.branches.hoursEnd": "Конец",
  "settings.branches.hoursHint": "Если оба поля пусты, филиал работает круглосуточно.",
  "settings.branches.week": "Дни недели",
  "settings.branches.weekHint": "День без времени работает по общим часам выше.",
  "settings.branches.dayOff": "Выходной",
  "settings.branches.ownDays": "есть особые дни",
  "settings.branches.day.mon": "Понедельник",
  "settings.branches.day.tue": "Вторник",
  "settings.branches.day.wed": "Среда",
  "settings.branches.day.thu": "Четверг",
  "settings.branches.day.fri": "Пятница",
  "settings.branches.day.sat": "Суббота",
  "settings.branches.day.sun": "Воскресенье",
  "settings.branches.hoursHalf": "Укажите оба времени или оставьте оба поля пустыми.",

  "settings.lossReasons.title": "Причины потери",
  "settings.lossReasons.add": "+ Добавить причину",
  "settings.lossReasons.empty": "Причин потери нет",
  "settings.expenseCategories.title": "Категории расходов",
  "settings.expenseCategories.add": "+ Добавить категорию",
  "settings.expenseCategories.empty": "Категорий расходов нет",
  "settings.expenseCategories.requiresVendor": "Нужны поставщик и сделка",
  "settings.list.name": "Название",
  "settings.list.yes": "Да",
  "settings.list.no": "Нет",

  "finance.rate.cbu": "Курс: курс ЦБ",
  "finance.rate.crossing": "Курс: курс поставщика из брони. Если в брони его нет, вводится вручную.",
  "finance.rate.manualLabel": "Курс: сколько сумов за 1 USD",

  "finance.expense.status": "Статус",
  "finance.expense.stornoStatus": "СТОРНО",
  "finance.expense.stornoAction": "Сторно",
  "finance.expense.stornoTitle": "Сторно расхода",
  "finance.expense.stornoHint": "Расход не удаляется: добавляется обратная запись, обе остаются в истории.",
  "finance.expense.stornoReason": "Причина",
  "finance.expense.stornoConfirm": "Сторнировать",
  "finance.expense.stornoClose": "Закрыть",
  "finance.expense.stornoFailed": "Не удалось сторнировать. Попробуйте ещё раз.",

  "offer.beachDistance": "До пляжа {meters} м",
};
